<template>
  <div>
    <a-tabs>
      <a-tab-pane :tab="v.menu_name" v-for="v in homeList" :key="v.id">
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='v.children'>
          <template v-slot:action="{ record }">
            <a-button type="primary" @click='checkBnt(record,v.menu_name)' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}
            </a-button>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <div class="s_flex_center m-t-10">
      <a-button type="primary" @click='confirm'>确定</a-button>
    </div>
  </div>
</template>

<script>
  import { onMounted, reactive, ref, toRefs } from "@vue/runtime-core";
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  import { getStoreClerkUsedMenu } from '@/api/clerk'
  const columns = [
    {
      title: "应用名称",
      dataIndex: "menu_name",
      key: "menu_name",
    },
    {
      title: "操作",
      key: "action",
      width: 150,
      slots: { customRender: "action" },
    },
  ];
  export default {
    name: "moduleSelect",
    props: {
      selectList: {
        type: Array,
      }
    },
    setup(props, { emit }) {
      const state = reactive({
        selectList: [],
        homeList: [
          {
            name: "云店管理",
            children: [
              {
                name: "云店订单",
                icon: "yddd",
                checked: false,
                url: "/pages/order/order_list",
              },
              {
                name: "社交电商",
                icon: "sjds",
                checked: false,
                url: "/pages/distribution_center/index",
              },
              {
                name: "直播海报",
                icon: "zbhb",
                checked: false,
                url: "/pages/live/index",
              },
              {
                name: "秒杀海报",
                icon: "mshb",
                checked: false,
                url: "/pages/seckill/index",
              },
              {
                name: "拼团海报",
                icon: "pthb",
                checked: false,
                url: "/pages/group/index",
              },
            ],
          },
          {
            name: "人员管理",
            children: [
              {
                name: "我的客户",
                icon: "wdkh",
                checked: false,
                url: "/pages/customer/customer",
              },
              {
                name: "我的业绩",
                icon: "dyyj",
                checked: false,
                url: "/pages/clerk/clerk_grades_customer",
              },
            ]
          },
          {
            name: "核销管理",
            children: [
              {
                name: "核销记录",
                icon: "hxjl",
                checked: false,
                url: "/pages/order/order_write",
              },
              {
                name: "店铺核销码",
                icon: "dphxm",
                checked: false,
                url: "/pages/placeAnOrder/index",
								type: 'click'
              },
              {
                name: "权益卡礼品",
                icon: "qyklp",
                checked: false,
                url: "/pages/rightsCard/rightsCardLog",
              },
            ]
          },
          {
            name: "超级导购",
            children: [
              {
                name: "扫码领奖",
                icon: "smlj",
                checked: false,
                url: "/pages/guide/index",
								type:'qrcode'
              },
              {
                name: "扫码奖项明细",
                icon: "smjxmx",
                checked: false,
                url: "/pages/guide/awardDetails",
              },
              {
                name: "扫码积分",
                icon: "smjf",
                checked: false,
                url: "/pages/guide/scanIntegral",
              },
            ]
          }
        ]
      })
      //获取菜单
      const getMenu = async () => {
        let result = await getStoreClerkUsedMenu().then(res => res.data).catch(error => error);
        if (iscode(result)) {
          state.homeList = result.data;
          initData();
        } else {
          message.error(result.msg);
        }
      }
      const initData = async () => {
        if (state.selectList || state.selectList.length > 0) {
          state.homeList.forEach((i) => {
            i.children.forEach((k) => {
              if (
                state.selectList.find((v) => {
                  return k.id == v.id;
                })
              ) {
                k.select = true;
              }
            });
          });
        }
      };

      onMounted(() => {
        if (props.selectList) {
          state.selectList = JSON.parse(JSON.stringify(props.selectList));
        }
        getMenu();
      });

      //多选
      const checkBnt = (e,name) => {
        if (!e.select) {
          if (state.selectList.length == 8) {
            message.error("最多添加8个常用菜单")
            return
          }
          state.selectList.push({...e,module:name});
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.id == e.id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select;
      };
      //多选确认
      const confirm = () => {
        emit("select",  state.selectList);
      };
      return {
        ...toRefs(state),
        columns,
        checkBnt,
        confirm,
      };
    },
  };
</script>